import { Expose, Type } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";
import { HouseholdClaimProductCode } from "src/containers/household-claim/models/claim-product-code";
import { HouseholdClaimCacheFile } from "./claim-cache-file.model";
import { HouseClaimCacheRefundBank } from "./claim-cache-refund-bank.model";
import { Properties } from "../types";

export enum HouseholdClaimCacheStatus {
    Open = "OPENED",
    Closed = "CLOSED",
}

type EvaluationStatus =
    | "Aprobado"
    | "Liquidación"
    | "Terminado"
    | "004 - Liquidado"
    | null;
export const APPROVED_EVALUATION_STATUS: EvaluationStatus[] = [
    "Aprobado",
    "Liquidación",
    "Terminado",
    "004 - Liquidado",
];
type EvaluationUserResponse = boolean | null;
type StepProcess = "document" | "adjuster" | null;
type Compensation = {
    evaluationStatus: EvaluationStatus;
    amount: number | null;
};

export class HouseholdClaimCache extends BaseModel {
    @Expose() iaProcess = true;
    @Expose() date = "20/07/2022";
    @Expose() adjusterId = 0;
    @Expose() stepProcess: StepProcess = null;
    @Expose() evaluationUserResponse: EvaluationUserResponse = null;
    @Expose() compensation: Compensation = {
        evaluationStatus: "Aprobado",
        amount: 0,
    };
    @Expose() policyId = 0;
    @Expose() currency = "";
    @Expose() productCode: HouseholdClaimProductCode | null = null;
    @Expose() coverageIds: number[] = [];
    @Expose() address = "";
    @Expose() detail = "";
    @Expose() detailDocuments = "";
    @Expose() email = "";
    @Expose() existsObjectsOutsidePolicy = false;
    @Expose() formPage = 0;
    @Expose() id = 0;
    @Expose() status = HouseholdClaimCacheStatus.Open;
    @Expose() policyCurrency = "";
    @Expose()
    @Type(() => HouseClaimCacheRefundBank)
    bank: Nullable<HouseClaimCacheRefundBank> = new HouseClaimCacheRefundBank();
    @Expose()
    @Type(() => HouseholdClaimCacheFile)
    files: HouseholdClaimCacheFile[] = [];
    @Expose() help = "";

    copyWith(
        params: Partial<Properties<HouseholdClaimCache>>
    ): HouseholdClaimCache {
        return Object.assign(Object.create(HouseholdClaimCache.prototype), {
            ...this,
            ...params,
        });
    }
}
